module.exports = __webpack_public_path__ + "static/media/BLUSH_3872.47de97f1.jpg";